const MODULE_NAME = 'schoolReducer';

const SchoolSelector = {
    schoolList: (state) => state[MODULE_NAME].schoolList,
    currentSchool: (state) => state[MODULE_NAME].currentSchool,
    isShowModal: (state) => state[MODULE_NAME].isShowModal,
    listSchoolMap: (state) => state[MODULE_NAME].listSchoolMap,
};

export default SchoolSelector;
